import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMapPointer32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconMapPointer32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M24 13c0 2.667-1.498 6.267-3.54 9.328-.997 1.496-2.053 2.756-2.986 3.614-.468.43-.865.724-1.173.9a2 2 0 0 1-.301.144 2 2 0 0 1-.301-.145c-.308-.175-.705-.468-1.173-.899-.933-.858-1.99-2.118-2.987-3.614C9.5 19.267 8 15.667 8 13a8 8 0 1 1 16 0m2 0c0 6.5-7 16-10 16S6 19.5 6 13C6 7.477 10.477 3 16 3s10 4.477 10 10m-8 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0m2 0a4 4 0 1 1-8 0 4 4 0 0 1 8 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconMapPointer32);
